export default __webpack_public_path__ + "static/127-min-min-83654d3a21b620093a810c8d62348dee.jpg";